import { defineStyle } from '@chakra-ui/react';

const theme = defineStyle({
  root: {
    // zIndex: 2,
    // position: 'absolute',

    w: '100%',
    height: {
      base: 'headerMobileSize',
      lg: 'headerDesktopSize',
    },
    minH: {
      base: 'headerMobileSize',
      lg: 'headerDesktopSize',
    },
    borderBottom: '1px solid rgba(0, 23, 49, 0.32)',
    py: '32px',
    px: '40px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    article: {
      bg: 'red',
    },
  },
  logo: {
    w: { base: '114px', lg: 'auto' },
  },
  logoSignOut: {
    w: '25px',
    h: '25px',
  },
  logoToggleMenu: {
    width: '30px',
    height: '22px',
    fill: 'black',
  },
  topRightContent: {
    align: 'center',
    gap: '30',
  },
  signOut: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  progressContainer: {
    _rtl: {
      width: {
        base: '0px',
        md: '45%',
        lg: '42%',
        xl: '52%',
        '2xl': '52%',
      },
    },
    _ltr: {
      width: {
        base: '0px',
        md: '45%',
        lg: '42%',
        xl: '52%',
        '2xl': '55%',
      },
    },
    '@media screen and (min-width: 1101px) and (max-width: 1209px)': {
      _rtl: {
        width: '42%',
      },
      _ltr: {
        width: '43%',
      },
    },
    '@media screen and (min-width: 1210px) and (max-width: 1280px)': {
      _rtl: {
        width: '45%',
      },
      _ltr: {
        width: '48%',
      },
    },

    '@media screen and (min-width: 1480px) and (max-width: 1560px)': {
      _rtl: {
        width: '55%',
      },
      _ltr: {
        width: '55%',
      },
    },
    '@media screen and (min-width: 1561px) and (max-width: 1661px)': {
      _rtl: {
        width: '58%',
      },
      _ltr: {
        width: '60%',
      },
    },
    '@media screen and (min-width: 1662px) and (max-width: 1761px)': {
      _rtl: {
        width: '60%',
      },
      _ltr: {
        width: '62%',
      },
    },
    '@media screen and (min-width: 1762px) and (max-width: 1859px)': {
      _rtl: {
        width: '62%',
      },
      _ltr: {
        width: '65%',
      },
    },
    '@media screen and (min-width: 1860px)': {
      _rtl: {
        width: '67%',
      },
      _ltr: {
        width: '67%', // for very large screens
      },
    },
  },
});
export default theme;
